module.exports = __webpack_public_path__ + "static/media/notification-white.f785e278.svg";